import { firebase } from '../../../config/firebase'
import { buildNormalizedTaxonomyState } from './productTaxonomyFields'

export function catalogTaxonomyServerTimestamp() {
  return firebase.firestore.FieldValue.serverTimestamp()
}

/**
 * Patch for a taxonomy write (assignments / membership / canonical + updatedAt).
 */
export function buildProductTaxonomyWritePatch({
  assignmentIds,
  previousCanonical,
  nodesById,
  canonicalOverride = undefined,
}) {
  let next = buildNormalizedTaxonomyState({
    assignmentIds,
    previousCanonical,
    nodesById,
  })

  if (canonicalOverride !== undefined) {
    const assignments = next.catalogTaxonomyAssignmentIds
    if (canonicalOverride == null) {
      next = {
        ...next,
        canonicalCatalogTaxonomyNodeId: null,
      }
    } else if (assignments.includes(canonicalOverride)) {
      next = {
        ...next,
        canonicalCatalogTaxonomyNodeId: canonicalOverride,
      }
    }
  }

  return {
    catalogTaxonomyAssignmentIds: next.catalogTaxonomyAssignmentIds,
    catalogTaxonomyMembershipIds: next.catalogTaxonomyMembershipIds,
    canonicalCatalogTaxonomyNodeId: next.canonicalCatalogTaxonomyNodeId,
    catalogTaxonomyUpdatedAt: catalogTaxonomyServerTimestamp(),
  }
}
